export default __webpack_public_path__ + "static/media/Bismillah.58b0c364.mp3";